import Handlebars from "handlebars"
import { stringHelpers } from "./string"
import { numberHelpers } from "./number"
import { arrayHelpers } from "./array"
import { objectHelpers } from "./object"

Handlebars.registerHelper({ ...stringHelpers, ...numberHelpers, ...arrayHelpers, ...objectHelpers })

export { Handlebars }
